import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import { Image, Modal } from "react-bootstrap";
import generiqueNoir from "../../assets/images/sousmenu/icon_generique_noir.png";
import onenoteNoir from "../../assets/images/sousmenu/icon_onenote_noir.png";
import sharepointNoir from "../../assets/images/sousmenu/icon_sharepoint_noir.png";
import powerbiNoir from "../../assets/images/sousmenu/icon_powerbi_noir.png";
import pointNoir from "../../assets/images/sousmenu/icon_point_noir.png";
import silaeNoir from "../../assets/images/sousmenu/icon_silae_noir.png";
import flipboardNoir from "../../assets/images/sousmenu/icon_flipboard_noir.png";
import mediaNoir from "../../assets/images/sousmenu/icon_media_noir.png";
import pdfNoir from "../../assets/images/sousmenu/icon_pdf_noir.png";
import missionNoir from "../../assets/images/sousmenu/icon_missions_noir.png";
import pacteNoir from "../../assets/images/sousmenu/icon_pacte.png";
import teamsNoir from "../../assets/images/sousmenu/icon_teams.png";
import colideeNoir from "../../assets/images/sousmenu/icon_colidee.png";

import { MdGridView } from "react-icons/md";
import { BsCalendar2Week } from "react-icons/bs";

const ComponentToggle = (props) => {
  const { t } = useTranslation();
  /* La variale max depend du cran que l'on propose si on passe 4 ce sera sur un mois, un 6 proposera 1 an et un 7 proposera depuis toujours */
  const {
    switchView,
    setAnteriorite,
    viewToggle,
    max,
    min,
    curseurInitial,
    afficheGraduation = true,
    pageConcernee,
    sousMenus,
    disabled,
  } = props;
  const [intervalle, setIntervalle] = useState();
  const [titreToggle, setTitreToggle] = useState();
  const [curseur, setCurseur] = useState(curseurInitial ? curseurInitial : 4);
  const [controlPopup, setControlPopup] = useState(false);
  const [liensPopup, setLiensPopup] = useState([]);
  const [titrePopup, setTitrePopup] = useState("");

  useEffect(() => {
    switch (curseur) {
      case -1:
        setAnteriorite(-1);
        setIntervalle(t("public.bandeau.intervalle1"));
        break;
      case 0:
        setAnteriorite(0);
        setIntervalle(t("public.bandeau.intervalle0"));
        break;
      case 1:
        setAnteriorite(7);
        setIntervalle(t("public.bandeau.intervalle7"));
        break;
      case 2:
        setAnteriorite(14);
        setIntervalle(t("public.bandeau.intervalle14"));
        break;
      case 3:
        setAnteriorite(21);
        setIntervalle(t("public.bandeau.intervalle21"));
        break;
      case 4:
        setAnteriorite(31);
        setIntervalle(t("public.bandeau.intervalle31"));
        break;
      case 5:
        setAnteriorite(180);
        setIntervalle(t("public.bandeau.intervalle180"));
        break;
      case 6:
        setAnteriorite(365);
        setIntervalle(t("public.bandeau.intervalle365"));
        break;
      case 7:
        setAnteriorite(50000);
        setIntervalle(t("public.bandeau.intervalleToujours"));
        break;
      default:
        setAnteriorite(31);
        setIntervalle(t("public.bandeau.intervalle31"));
        break;
    }
  }, [curseur]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // switch (pageConcernee) {
    //   case "utiliser":
    //     setTitreToggle(t("public.bandeau.titreToggleUtiliser"));
    //     break;
    //   default:
    //     setTitreToggle(t("public.bandeau.titreToggle"));
    //     break;
    // }
  }, [pageConcernee]); // eslint-disable-line react-hooks/exhaustive-deps

  const chargePopup = (typeLiens) => {
    if (typeLiens === "pactes") {
      setTitrePopup(t("public.applicationsExternes.les_pactes"));
      setLiensPopup(sousMenus.filter((item) => item.icone === "pacte"));
    }
    if (typeLiens === "classiques") {
      setTitrePopup(t("public.applicationsExternes.outils"));
      setLiensPopup(sousMenus.filter((item) => item.icone !== "pacte"));
    }

    setControlPopup(true);
  };

  const handleClose = () => {
    setControlPopup(false);
  };

  const switchIcon = (icone) => {
    switch (icone) {
      case "generique":
        return generiqueNoir;

      case "pointjaune":
        return pointNoir;

      case "silae":
        return silaeNoir;

      case "onenote":
        return onenoteNoir;

      case "sharepoint":
        return sharepointNoir;

      case "powerbi":
        return powerbiNoir;

      case "flipboard":
        return flipboardNoir;

      case "media":
        return mediaNoir;

      case "pdf":
        return pdfNoir;

      case "mission":
        return missionNoir;

      case "pacte":
        return pacteNoir;

      case "teams":
        return teamsNoir;

      case "colidee":
        return colideeNoir;

      default:
        return "";
    }
  };

  const verifPactesExists = () => {
    let pactes = sousMenus.filter((item) => item.icone === "pacte");
    return pactes.length;
  };

  const verifLiensHorsPactesExists = () => {
    let horsPactes = sousMenus.filter((item) => item.icone !== "pacte");
    return horsPactes.length;
  };

  return (
    <div className={viewToggle ? "declinaisonChrono" : "declinaisonCategorie"}>
      <div className="containerToggleChrono btnLikeHugoBossContainer d-flex  align-items-center justify-content-center">
        {/* Bouton PACTES */}
        <div
          className={`btnLikeHugoBoss ${verifPactesExists() >= 1 ? "" : "btnLikeHugoBossDisabled"}`}
          onClick={(e) => (verifPactesExists() >= 1 ? chargePopup("pactes") : null)}
        >
          <span>{t("public.applicationsExternes.pactes")}</span>
        </div>
        {/* FIN Bouton PACTES */}

        {/* Bouton TIMELINE */}
        <div className="btnLikeHugoBoss btnLikeHugoBossMiddle d-flex align-items-center justify-content-center flex-no-wrap">
          <MdGridView size="1.8em" className="me-2" />
          <Form.Check
            className="Monswitch"
            type="switch"
            value={viewToggle}
            onChange={switchView}
            checked={!viewToggle ? "" : "checked"}
            disabled={disabled}
          />
          <BsCalendar2Week size="1.5em" className="ms-2" />
          {/* <span>icone{titreToggle}</span> */}
        </div>
        {/* FIN Bouton TIMELINE */}

        {/* Bouton OUTILS */}
        <div
          className={`btnLikeHugoBoss ${
            verifLiensHorsPactesExists() >= 1 ? "" : "btnLikeHugoBossDisabled"
          }`}
          onClick={(e) => (verifLiensHorsPactesExists() >= 1 ? chargePopup("classiques") : null)}
        >
          <span>{t("public.applicationsExternes.outils")}</span>
        </div>
        {/* FIN Bouton OUTILS */}

        {afficheGraduation && viewToggle && (
          <div
            className="d-flex align-items-center justify-content-center graduationSlider"
            style={{ opacity: viewToggle ? "" : "0.4" }}
          >
            <div className="ms-2  me-2">
              <Form.Range
                className="mt-2"
                min={min}
                disabled={viewToggle ? false : true}
                max={max}
                step="1"
                value={curseur}
                onChange={(e) => setCurseur(parseInt(e.target.value))}
              />
            </div>
            <span style={{ width: "100px" }}>{intervalle}</span>
          </div>
        )}
      </div>

      <Modal size="lg" show={controlPopup} onHide={handleClose} className="modalLiensSousMenus">
        <Modal.Header closeButton>
          <Modal.Title> {titrePopup}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {liensPopup.map((item, index) => (
            <div className="liensSousMenu" key={"sousMenu_" + index}>
              <a href={item.url} target="_blank" rel="noreferrer">
                <Image src={switchIcon(item.icone)} className="ms-2 me-2" /> {item.nom}
              </a>
            </div>
          ))}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ComponentToggle;
